import { gql } from '@apollo/client';

export const LISTINGS_SEARCH_QUERY = gql`
  query ListingsSearch($filters: [FilterParam!], $sortKeys: [SortKey!], $skip: Int, $limit: Int) {
    listingsSearch(filters: $filters, sortKeys: $sortKeys, skip: $skip, limit: $limit) {
      listings {
        id
        make
        year
        model
        trimId
        trim
        heading
        description
        externalId
        bodyType
        bodyTypeOther
        colorType
        colorTypeOther
        conditionType
        doorType
        doorTypeOther
        drivetrainType
        drivetrainTypeOther
        cylinderType
        cylinderTypeOther
        fuelType
        fuelTypeOther
        images {
          id
          location
          external
          primary
          order
        }
        city
        state
        zipCode
        showContactInfo
        listingDate
        expireDate
        deleteDate
        status
        statusDate
        mileage
        price
        transmissionType
        transmissionTypeOther
        titleStatus
        userId
        viewCount
      }
      aggregates {
        count
        yearMin
        yearMax
        priceMin
        priceMax
      }
    }
  }
`;

export const LISTINGS_BY_USER_QUERY = gql`
  query ListingsFindByUser($filters: [FilterParam!]) {
    listingsFind(filters: $filters) {
      heading
      id
      listingDate
      expireDate
      deleteDate
      status
      price
      images {
        id
        location
        external
        primary
        order
      }
    }
  }
`;

export const LISTINGS_SEARCH_RECENT = gql`
  query ListingsSearchRecent($count: Int!) {
    listingsSearchRecent(count: $count) {
      id
      make
      year
      model
      trimId
      trim
      heading
      description
      externalId
      bodyType
      bodyTypeOther
      colorType
      colorTypeOther
      conditionType
      doorType
      doorTypeOther
      drivetrainType
      drivetrainTypeOther
      cylinderType
      cylinderTypeOther
      fuelType
      fuelTypeOther
      images {
        id
        location
        external
        primary
        order
      }
      city
      state
      zipCode
      showContactInfo
      listingDate
      expireDate
      deleteDate
      status
      statusDate
      mileage
      price
      transmissionType
      transmissionTypeOther
      titleStatus
      userId
      viewCount
    }
  }
`;
